<template>
<div id="app">
  <Navbar v-if="showNavbar"/>
  <transition name="router-anim">
  <router-view/>
  </transition>
</div>
</template>

<script>
import Navbar from '@/components/layout/Navbar'
export default {
  name: 'App',
  components: {
    Navbar
  },
  data(){
    return{
      showNavbar: true,
      showBackButton: true
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}
html, body{
  height: 100%;
}
body.list {
    background-image: none;
    background-color: #f5f6fa;
}
body.signup {
    background-image: url("assets/SignUp.jpg") ;
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: cover;
}
Navbar.hide{
  display: none;
}
Navbar.show{
  display: block;
}
body.registration{
    background-image: none;
    background-color: white;
}
.router-anim-enter-active {
  /* animation: coming 1s; */
  animation: coming .5s;
  animation-delay: .5s;
  opacity: 0;
}
.router-anim-leave-active {
  /* animation: going 1s; */
  animation: going .5s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-20px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@font-face {
    font-family: GothamBold;
    src: url("assets/Gotham Bold.otf");
}
@font-face {
    font-family: GothamBook;
    src: url("assets/Gotham Book Regular.otf");
}
@font-face {
    font-family: GothamRndSSm-Book;
    src: url("assets/GothamRndSSm-Book.otf");
}
@font-face {
    font-family: GothamRndSSm-Light;
    src: url("assets/GothamRndSSm-Light.otf");
}
</style>



// WEBPACK FOOTER //
// src/App.vue